import components from "./components/index"
import dialogs from "./dialogs/index"
import globalPages from "./pages-global/index"
import manager from "./pages-manager/index"
import technician from "./pages-technician/index"
import utils from "./utils/index"

const pages = process.env.IS_MANAGER_MODE ? manager : technician

export default {
  ...components,
  ...dialogs,
  ...globalPages,
  ...pages,
  ...utils,
}
